import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { AutoUnsubscribe, IconNames, MenuItemModel } from '../../../common';
import { BehaviorSubject, Subscription } from 'rxjs';
import { DASHBOARD_MAIN_MENU_CONFIG } from '../constants/dashboard-main-menu-config';
import { Event, NavigationEnd, Router } from '@angular/router';
import { AppFacade } from '../../../store/state/app/app.facade';
import { SvgIconFacade } from '../../../store/state/svg-icon';

@Component({
  selector: 'dashboard-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class NavBarComponent implements OnInit {
  @Input() sideNavDrawer: MatDrawer;
  @Input() activeMenuItem$: BehaviorSubject<string>;
  @Input() menuNavigation$: BehaviorSubject<string>;

  menuStructure: MenuItemModel[] = DASHBOARD_MAIN_MENU_CONFIG;
  subscriptions: Subscription[] = [];
  subPanelNavigation$ = new BehaviorSubject<string>('');
  iconNameList = IconNames;
  svgPath = 'assets/core/icons/up.svg';

  constructor(
    public appFacade: AppFacade,
    private router: Router,
    private cd: ChangeDetectorRef,
    private svgIconFacade: SvgIconFacade,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.activeMenuItem$.subscribe((title: string) => {
        if (title) {
          this.menuNavigation$.next(title);
          this.sideNavDrawer.open();
          this.cd.detectChanges();
        }
      }),
      this.router.events.subscribe((val: Event) => {
        if (val instanceof NavigationEnd && this.sideNavDrawer) {
          this.sideNavDrawer.close();
        }
      }),
    );

    if (!this.svgIconFacade.getSvgIconMap().has(this.svgPath)) {
      this.svgIconFacade.loadSvgIcon(this.svgPath);
    }
  }
}
